import { useState } from 'react';
import { getActiveStore } from '@/lib/scope';

export function usePdaMode() {
  const [enabled, setEnabled] = useState(() => {
    try { const value = localStorage.getItem('pos-pda-mode:v1'); if (value !== null) return value === '1'; } catch { /* use screen default */ }
    return !!window.matchMedia?.('(max-width: 600px)').matches;
  });
  return [enabled, value => { try { localStorage.setItem('pos-pda-mode:v1', value ? '1' : '0'); } catch { /* current session only */ } setEnabled(value); }];
}
export const pdaKey = (user, kind) => `pda:v1:${window.location.host}:${user?.id}:${getActiveStore()}:${kind}`;
export function readPda(key) {
  try { return JSON.parse(localStorage.getItem(key)) || {}; } catch { return {}; }
}
export function warehouseLines(items) {
  return items.map((i,index) => ({ product_id:i.product_id || null, scan_order:Number.isInteger(i.scan_order)?i.scan_order:index, ...(i.temporary ? {temporary_id:i.temporary_id,product_name:i.product_name,barcode:i.barcode,base_unit:i.base_unit} : {}),
    quantity:Number(i.quantity),unit:i.unit,pieces:Number(i.pieces),cost:i.cost ?? null,variant:i.variant || null,condition:i.condition || 'SESUAI' }));
}
// Do not merge unlike units/conditions silently; the receiving conversion must stay explicit.
export function pdaAdd(items, product, unit, qty, warehouse, editing=false, condition='SESUAI', variant=null) {
  // Normalize older drafts once, then retain an immutable ordinal as each
  // product is first scanned. Re-scanning/editing never changes its position.
  const ordered=items.map((item,index)=>({...item,scan_order:Number.isInteger(item.scan_order)?item.scan_order:index}));
  const n=Number(qty), field=warehouse?'quantity':'qty';
  if (!Number.isInteger(n) || n<1 || n>1000000 || n*unit.pieces>1000000) throw new Error('Isi QTY bulat positif, maksimal satu juta satuan dasar.');
  const prior=ordered.find(i=>i.product_id===product.id);
  if (prior && !editing && (prior.unit!==unit.name || Number(prior.pieces)!==Number(unit.pieces) || (warehouse && ((prior.condition || 'SESUAI')!==condition || (prior.variant || null)!==(variant || null)))))
    throw new Error('Barang sudah ada dengan satuan/varian/kondisi berbeda. Buka Ubah QTY pada baris asal atau minta admin memeriksa.');
  const total=editing?n:Number(prior?.[field] || 0)+n;
  if (total*unit.pieces>1000000) throw new Error('Total melebihi satu juta satuan dasar.');
  const nextOrder=ordered.reduce((max,item)=>Math.max(max,item.scan_order),-1)+1;
  const row={...prior,product_id:product.id,product_name:product.name,name:product.name,base_unit:product.base_unit,
    scan_order:prior?.scan_order ?? nextOrder,
    unit:unit.name,pieces:Number(unit.pieces),[field]:total,units:product.units,cost:prior?.cost ?? null,condition,variant};
  const index=ordered.findIndex(i=>i.product_id===product.id);
  if(index<0)return [...ordered,row];
  return ordered.map((item,n)=>n===index?row:item);
}
